import { ActionList, Icon, Popover } from '@shopify/polaris';
import { CheckIcon } from '@shopify/polaris-icons';
import { useState } from 'react';
import TooltipWithAction from '../TooltipWithAction';
import CustomBadge from '../CustomBadge';

// Định nghĩa enum cho Font Size
export enum FontSize {
  XSmall = '10px', // size 1
  Small = '13px', // size 2
  Base = '16px', // size 3
  Medium = '18px', // size 4
  Large = '24px', // size 5
  XLarge = '32px', // size 6
  XXLarge = '48px', // size 7
}

// Danh sách font size với label
export const FONT_SIZES = [
  { label: '10px', value: FontSize.XSmall },
  { label: '13px', value: FontSize.Small },
  { label: '16px', value: FontSize.Base },
  { label: '18px', value: FontSize.Medium },
  { label: '24px', value: FontSize.Large },
  { label: '32px', value: FontSize.XLarge },
  { label: '48px', value: FontSize.XXLarge },
];

export const getFontSizeValue = (size: FontSize): number => {
  switch (size) {
    case FontSize.XSmall:
      return 1; // 10px
    case FontSize.Small:
      return 2; // 13px
    case FontSize.Base:
      return 3; // 16px
    case FontSize.Medium:
      return 4; // 18px
    case FontSize.Large:
      return 5; // 24px
    case FontSize.XLarge:
      return 6; // 32px
    case FontSize.XXLarge:
      return 7; // 48px
    default:
      return 2; // Default size (16px)
  }
};

interface FontSizeButtonProps {
  selectedSize: FontSize;
  setSelectedSize: (size: FontSize) => void;
  instanceId: string;
  disabled?: boolean;
}

const FontSizeButton = ({ selectedSize, setSelectedSize, instanceId, disabled }: FontSizeButtonProps) => {
  const [active, setActive] = useState(false);

  const handleFontSizeSelect = (size: FontSize) => {
    const sizeValue = getFontSizeValue(size);
    document.execCommand('fontSize', false, sizeValue.toString());
    setSelectedSize(size);
    setActive(false);
  };

  const componentForActivator = () => {
    return disabled ? (
      <TooltipWithAction content={<CustomBadge marginLeft={false} />} activatorWrapper="div">
        <button className="rsw-btn" style={{ cursor: 'not-allowed', opacity: '0.5' }}>
          {selectedSize.replace('px', '')}
        </button>
      </TooltipWithAction>
    ) : (
      <button data-editor-id={instanceId} className="rsw-btn" onClick={() => setActive(!active)} style={{ fontWeight: '500' }}>
        {selectedSize.replace('px', '')}
      </button>
    );
  };

  return (
    <Popover active={active} activator={componentForActivator()} onClose={() => setActive(false)}>
      <ActionList
        items={FONT_SIZES.map((size) => ({
          content: size.label,
          onAction: () => handleFontSizeSelect(size.value),
          suffix: size.value === selectedSize ? <Icon source={CheckIcon} /> : null,
        }))}
      />
    </Popover>
  );
};

export default FontSizeButton;
